'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  black: '#000',
  white: '#fff'
};

exports.default = common;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/colors/common.js
// module id = 1567
// module chunks = 39